import axios from "axios";
import { toast } from "react-toastify";
import config from "../config";

const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  axios.defaults.headers.common["TOKEN"] = token;
};

const setLang = (lang) => {
  axios.defaults.headers.common["lang"] = lang;
};

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url, params) => {
    let response;

    let paramKeys = [];

    if (params) {
      Object.keys(params).map((key) => {
        paramKeys.push(key + "=" + params[key]);
        return paramKeys;
      });

      const queryString =
        paramKeys && paramKeys.length ? paramKeys.join("&") : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };
  /**
   * post given data to url
   */
  create = (url, data, config = {}) => {
    return axios.post(url, data, config);
  };

  /**
   * Upload FormData (multipart/form-data) similar to Swift implementation
   */
  upload = (url, formData, config = {}) => {
    // Set default headers for FormData
    const uploadConfig = {
      ...config,
      headers: {
        'Content-Type': 'multipart/form-data',
        ...config.headers
      }
    };
    
    return axios.post(url, formData, uploadConfig);
  };

  /**
   * Updates data
   */
  update = (url, data, config = {}) => {
    return axios.put(url, data, config);
  };
  /**
   * Delete
   */
  delete = (url, config) => {
    return axios.delete(url, { ...config });
  };
}
export let isTokenOutDate = false;
// Set API URL with fallback and debug
const apiUrl = config.API_URL || "/api";
console.log('🔧 Setting API URL:', apiUrl);
console.log('🔧 Environment VITE_API_BASE_URL:', import.meta.env.VITE_API_BASE_URL);
console.log('🔧 Config API_URL:', config.API_URL);
console.log('🔧 Final API URL:', apiUrl);
axios.defaults.baseURL = apiUrl;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";
// CORS headers
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers.common["Access-Control-Allow-Methods"] = "GET, POST, PUT, DELETE, OPTIONS";
axios.defaults.headers.common["Access-Control-Allow-Headers"] = "Content-Type, Authorization, TOKEN, lang";
// Source header for all requests
axios.defaults.headers.common["source"] = "web";
// Add request interceptor to log URLs
axios.interceptors.request.use(
  function (config) {
    console.log('🌐 API Request:', {
      method: config.method?.toUpperCase(),
      url: config.url,
      baseURL: config.baseURL,
      fullURL: config.baseURL + config.url
    });
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    if (
      response?.data?.result?.meta?.message &&
      response?.data?.result?.meta?.status
    ) {
      // toast.success(response.data.result.meta.message);
    }

    if (response?.data?.result && response?.data?.result?.meta) {
      if (response.data.result.meta.status_code === 403) {
        localStorage.removeItem("authUser");
        window.location.assign("/logout");
      }
      if (!response?.data?.result?.meta?.status) {
        return Promise.reject(response.data.result.meta.message);
      }
    }
    return response?.data?.result?.data
      ? response?.data?.result?.data
      : response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;
    switch (error.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      case 404:
        message = "Sorry! the data you are looking for could not be found";
        break;
      default:
        message = error.message || error;
    }
    if (message !== "") {
      toast.error(message);
    } else {
      toast.error("Oop! Something went wrong...");
    }

    return Promise.reject(message);
  }
);

// Debug function to test API URL
export const testApiUrl = () => {
  console.log('🔧 API Configuration Debug:');
  console.log('- Config API_URL:', config.API_URL);
  console.log('- Axios baseURL:', axios.defaults.baseURL);
  console.log('- Current origin:', window.location.origin);
  console.log('- Full login URL:', axios.defaults.baseURL + '/login');
  console.log('- Environment VITE_API_BASE_URL:', import.meta.env.VITE_API_BASE_URL);
  console.log('- Hostname:', window.location.hostname);
  console.log('- Is Production:', window.location.hostname !== 'localhost');
};

export { APIClient, setAuthorization, setLang, getLoggedinUser };
